import type { ReactNode, FC } from 'react';

interface Props {
  className?: string;
  index: number;
  renderRow: (rowData: any, index?: number) => ReactNode;
  rowData: any;
}

const TableRow: FC<Props> = ({ className, index, rowData, renderRow }) => {
  return <tr className={className}>{renderRow(rowData, index)}</tr>;
};
TableRow.displayName = 'TableRow';

export default TableRow;
